module.exports = __webpack_public_path__ + "img/image-divide-blue.482a9170.svg";